import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Circle, Path} from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function LogoutIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (

    <Svg
      {...svgProps}
      viewBox="0 0 48 48">
       <G id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="Artboard" transform="translate(-92.000000, -175.000000)">
            <G id="LogOut" transform="translate(93.000000, 176.000000)">
                <G id="Group">
                    <G>
                        <Circle id="Oval" stroke="#FFFFFF" fill="none" cx="23" cy="23" r="23"></Circle>
                        <Path d="M19.1327667,24.02156 C18.8194,24.02156 18.5661,23.78808 18.5661,23.50052 L18.5661,23.50052 C18.5661,23.214 18.8194,22.98052 19.1327667,22.98052 L19.1327667,22.98052 L34.4333333,22.98052 C34.7455667,22.98052 34.9988667,23.214 34.9988667,23.50052 L34.9988667,23.50052 C34.9988667,23.78808 34.7455667,24.02156 34.4333333,24.02156 L34.4333333,24.02156 L19.1327667,24.02156 L19.1327667,24.02156 Z" id="Shape" fill="#FFFFFF" fillRule="nonzero"></Path>
                        <Path d="M28.0067667,18.34004 C27.7852,18.13672 27.7852,17.80808 28.0067667,17.60476 L28.0067667,17.60476 C28.2283333,17.40144 28.5864667,17.40144 28.8080333,17.60476 L28.8080333,17.60476 L34.8328333,23.13288 C35.0544,23.3362 35.0532667,23.66484 34.8317,23.86816 L34.8317,23.86816 C34.6101333,24.07148 34.252,24.07148 34.0315667,23.8692 L34.0315667,23.8692 L28.0067667,18.34004 L28.0067667,18.34004 Z" id="Shape" fill="#FFFFFF" fillRule="nonzero"></Path>
                        <Path d="M28.8091667,29.39576 C28.5876,29.59908 28.2294667,29.59908 28.0079,29.39576 L28.0079,29.39576 C27.7863333,29.19244 27.7863333,28.8638 28.0079,28.66048 L28.0079,28.66048 L34.0321333,23.13184 C34.2537,22.92852 34.6118333,22.92956 34.8334,23.13288 L34.8334,23.13288 C35.0549667,23.3362 35.0549667,23.66484 34.8345333,23.86712 L34.8345333,23.86712 L28.8091667,29.39576 L28.8091667,29.39576 Z" id="Shape" fill="#FFFFFF" fillRule="nonzero"></Path>
                    </G>
                    <Path d="M15,13.5416216 C15,13.3967568 15.0594314,13.2605405 15.1668651,13.1594595 L15.1668651,13.1594595 C15.2748702,13.0567568 15.4188771,13 15.5708843,13 L15.5708843,13 L26.4285442,13.0010811 C26.7445593,13.0010811 27,13.2427027 27,13.5416216 L27,13.5416216 C27,13.8394595 26.7445593,14.0821622 26.4285442,14.0821622 L26.4285442,14.0821622 L16.143483,14.0810811 L16.143483,31.9194595 L26.4285442,31.9194595 C26.7445593,31.9194595 27,32.1610811 27,32.4594595 L27,32.4594595 C27,32.7583784 26.7445593,33 26.4285442,33 L26.4285442,33 L15.5708843,33 C15.4188771,33 15.2748702,32.9437838 15.1668651,32.8416216 L15.1668651,32.8416216 C15.0594314,32.7394595 15,32.6032432 15,32.4594595 L15,32.4594595 L15,13.5416216 L15,13.5416216 Z" id="Shape" fill="#FFFFFF" fillRule="nonzero"></Path>
                </G>
            </G>
        </G>
    </G>
    </Svg>

  );
}

LogoutIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

LogoutIcon.defaultProps = {
  height: 120,
  width: 120,
};

export default pure(LogoutIcon);
